import axios from 'axios';
import {
  FETCH_CATEGORY,
  FETCH_CATEGORY_FAILED,
  FETCH_CATEGORY_SUCCESS,
  FETCH_CATEGORY_PRODUCT_SUCCESS,
  FETCH_CATEGORY_PRODUCT_FAILED
} from '../types';
import {
  BASE_URL
} from '../constants'
import Auth from '../../config/auth'

import storeId from '../../config/storeId'

const store = storeId();


export const fetchCategory = () => dispatch => {

  axios.get(`${BASE_URL}/products/category/list/${store}`)
    .then(response => {
      console.log(response)
      if (!response.hasError) {
        dispatch({
          type: FETCH_CATEGORY_SUCCESS,
          payload: response.data
        })
      } else {
        dispatch({
          type: FETCH_CATEGORY_FAILED,
          payload: response.data
        })
      }
    })
    .catch(err => {
      dispatch({
        type: FETCH_CATEGORY_FAILED,
        payload: {
          hasError: true,
          errors: {
            message: "network error",
            error: err.data
          }
        }
      })
    })
}

export const fetchAddCategory = (data) => dispatch => {
  const token = Auth.getToken();
  const headers = {
    Authorization: `Bearer ${token}`
  };
  axios.post(`${BASE_URL}/merchants/stores/category`, data, {
      headers
    })
    .then(response => {
      console.log(response)
      if (!response.hasError) {
        // dispatch({
        //   type: FETCH_CATEGORY_SUCCESS,
        //   payload: response.data
        // })
        dispatch(fetchCategory())
      } else {
        dispatch({
          type: FETCH_CATEGORY_FAILED,
          payload: response.data
        })
      }
    })
    .catch(err => {
      dispatch({
        type: FETCH_CATEGORY_FAILED,
        payload: {
          hasError: true,
          errors: {
            message: "network error",
            error: err.data
          }
        }
      })
    })
}


export const fetchCategoryProduct = (id) => dispatch => {

  axios.get(`${BASE_URL}/products/view/shobbu/${id}`)
    .then(response => {
      console.log(response)
      if (!response.hasError) {
        dispatch({
          type: FETCH_CATEGORY_PRODUCT_SUCCESS,
          payload: response.data
        })
      } else {
        dispatch({
          type: FETCH_CATEGORY_PRODUCT_FAILED,
          payload: response.data
        })
      }
    })
    .catch(err => {
      dispatch({
        type: FETCH_CATEGORY_FAILED,
        payload: {
          hasError: true,
          errors: {
            message: "network error",
            error: err.data
          }
        }
      })
    })
}
